//= ../Vendor/jquery/dist/jquery.js
//= ../Vendor/slick-1.9/slick/slick.js
//= ../Vendor/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js
//= ../Vendor/jquery-nice-select/js/jquery.nice-select.js
//= ../Vendor/jquery-match-height/dist/jquery.matchHeight.js
//= ../Vendor/bootstrap-4.1.0/dist/js/bootstrap.js
//= ../Vendor/kaleidoscope/dist/kaleidoscope.min.js
//= ../Vendor/aos/dist/aos.js

(function ($) {

	// DOM ready
	$(function () {
		$(".panel__content *").children().removeAttr("data-aos");
		$("[data-aos]").removeAttr("data-aos");

		// Cover image effect
		function coverImage() {
			$('*[data-js="cover-img"]').each(function (index) {
				var src = $(this).find('img').attr('src');
				$(this).find('img').css('opacity', '0');
				$(this).css({
					'background-image': 'url(' + src + ')'
				});
			});
		}

		function scrollTo(dest) {
			$('html, body').animate({
				scrollTop: ($(dest).offset().top)
			}, 500);
			// $('[data-link]').on("click", function (event) {
			// 	$('html, body').animate({
			// 		scrollTop: ($($(this).data('link')).offset().top)
			// 	}, 500);
			// });
		}

		// Datepicker
		/////////////
		$('.search-field-date input[type=text]').datepicker({dateFormat: 'dd.mm.yy'});

		$(".about-klinik .b-image-and-text .btn.btn-more").on("click", function () {
			$(this).parents(".about-klinik").find(".article-content-box").slideDown();
			$(this).addClass("btn-hidden");
		});

		$(".about-klinik .article-content .btn.btn-more").on("click", function () {
			$(this).parents(".about-klinik").find(".btn-more").removeClass("btn-hidden");
			$(this).parents(".article-content-box").slideUp();
		});

		// Header-Anchor
		$('.page-sections-nav li a').click(function () {
			event.preventDefault();
			$('html,body').animate({
				scrollTop: $(this.hash).offset().top - 50
			}, 500);
		});

		// 360 degree photo viewer
		function photo360Viewer(photoWidth, photoHeight, photoSrc, containerId) {
			var $container = '#' + containerId;
			var viewer = new Kaleidoscope.Image({
				source: photoSrc,
				containerId: $container,
				height: photoHeight,
				width: photoWidth,
			});
			viewer.render();

			window.onresize = function () {
				viewer.setSize({height: $($container).outerHeight(), width: $($container).outerWidth()});
			};
		}

		$('*[data-js="image-360deg-wrapper"]').each(function (index) {
			var photoWidth = $(this).outerWidth();
			var photoHeight = $(this).outerHeight();
			var photoSrc = $(this).find('img').attr('src');
			var containerId = $(this).attr('id');
			photo360Viewer(photoWidth, photoHeight, photoSrc, containerId);
		});

		// Main carousel
		// $('[data-js="main-carousel"]').slick({
		// 	slidesToShow: 1,
		// 	slidesToScroll: 1,
		// 	autoplay: false,
		// 	autoplaySpeed: 4000,
		// 	arrows: false,
		// 	dots: false
		// });

		$('.team-carousel').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			nextArrow: '<div class="slick-next"><i class="icon icon_drop-down-arr"></i></div>',
			prevArrow: '<div class="slick-prev"><i class="icon icon_drop-down-arr"></i></div>',
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2
				}
			}, {
				breakpoint: 776,
				settings: {
					slidesToShow: 1
				}
			}]
		});

		$('.quote-slider').slick();

		// Store parameter in sessionStorage to use it on referenced site
		$(".teaser-6 form").on("submit", function (e) {
			e.preventDefault();
			var text = $(this).find('.f-keyword').val();
			var href = $(this).find('.f-page').attr("href");
			window.sessionStorage.setItem('f3-text', text);
			// console.log(text);
			if (href) {
				// console.log(href);
				window.location.href = href;
			}
		});

		// Read parameter from sessionStorage and use it for search
		if ($(".ctype-asdoctors_list").length > 0) {
			var text = window.sessionStorage.getItem('f3-text');
			$('.ctype-asdoctors_list:first .f-2__search-field input').val(text);
			$(document).ready(function () {
				$(".ctype-asdoctors_list:first .f-2__search-field input").keyup();
				// AOS.refresh();
				scrollTo(".ctype-asdoctors_list:first");
			});
			window.sessionStorage.removeItem("f3-text");
		}

		var scrollToHash = window.sessionStorage.getItem("scrollTo");
		if (scrollToHash) {
			$(document).ready(function () {
				scrollTo("#" + scrollToHash);
				window.sessionStorage.removeItem("scrollTo");
			});
		}

		// Trigger search with button
		$('.ctype-asdoctors_list .f-2__search-field button').on("submit", function () {
			$(this).parents(".f-2__search-field").find("input").keyup();
			// AOS.refresh();
		});

		// Burger button
		$('a[data-js="btn-burger"]').on("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			if ($this.hasClass("active")) {
				$this.removeClass("active");
				$(".main-nav-list .list-open").removeClass("list-open");
				$(".main-nav-list .open").removeClass("open");
			} else {
				$this.addClass("active");
			}
		});

		// mobile navigation panels
		$(".nav-panel-btn").on("click", function () {
			var $li = $(this).parents("li");
			var $ul = $(this).next("ul");
			if ($li.hasClass("open")) {
				$ul.removeClass("list-open");
				$li.removeClass("open");
			} else {
				$ul.addClass("list-open");
				$li.addClass("open");
			}
		});

		$('*[data-js="scroll-top"]').on('click', function (e) {
			e.preventDefault();
			$('body, html').animate({
				scrollTop: 0
			}, 500);
		});

		// Main carousel caption navigation click handler
		/*$('.page-sections-nav li a').on('click', function () {
			var trg = $(this).attr('href');
			$('body, html').animate({
				scrollTop: $(trg).offset().top
			}, 500);
		});*/

		// Header search button
		$('.btn.btn-search').on('click', function (e) {
			e.preventDefault();
			var $header = $('.header__service-nav-line');
			if ($header.hasClass('search-active')) {
				$header.removeClass('search-active');
			} else {
				$header.addClass('search-active');
				$(".search-field input").focus();
			}
		});

		$(".scroll-next").on("click", function (e) {
			e.preventDefault();
			$("body, html").animate({
				scrollTop: $(this).parents("section").next("section").offset().top
			}, 500);
		});

		// Close search or language select panels if they are opened when click outside
		$(document).on('click', function (e) {
			var target = $(e.target);
			if (target.parent().is($('div')) || target.is($('header, section, div, nav, body'))) {
				$('.header__lang-search .lang-list li ul').removeClass('open');
				$('.header__lang-search .search-block .search-field').removeClass('open');
				$('.header__lang-search .search-block button').show();
				$('.header__lang-search .lang-list li.active>a').show();
			}
		});

		// Panels
		$('[data-js="panel"] .panel__title .plus-icon-area, [data-js="panel"] .panel__title .heading-area:not(.d-block)').on('click', function () {
			if ($(this).parent().parent().hasClass('opened')) {
				$('[data-js="panel"]').removeClass('opened');
			} else {
				$('[data-js="panel"]').removeClass('opened');
				$(this).parent().parent().addClass('opened');
			}
		});

		$(document).ready(function () {
			$("table").wrap('<div class="table-scrollable"></div>');

			if ($(".tx-as-doctors").length > 0) {
				var plugin = $(".tx-as-doctors");
				var selectfield = plugin.find('.selector--select-categories');
				var searchfield = plugin.find('.selector--search');

				searchfield.keyup(function () {
					// AOS.refresh();
				});

				selectfield.change(function () {
					// AOS.refresh();
				});
			}

			$(".content-line").each(function () {
				$(this).find(".lightbox").magnificPopup({
					type: "image",
					closeOnContentClick: true,
					tLoading: "Loading image #%curr%...",
					mainClass: "mfp-img-mobile",
					gallery: {
						enabled: true
					},
					image: {
						titleSrc: function (item) {
							var title = '';
							var img = item.el.find("img");
							var a_title = img.attr("title");
							if (typeof a_title != "undefined" && (a_title.length > 0)) {
								title = "<span class='title'>" + a_title + "</span>";
							}
							if ((img.length > 0) && img.attr("data-description")) {
								title += (a_title ? "" : "") + "'<span class='copyright'>" + img.attr("data-description") + "</span>";
							}
							return title;
						}
					}
				});
			});
		});

		$(window).on("resize", function () {
			var ww = $(window).outerWidth();

			// $('*[data-js="image-360deg-wrapper"]').each(function (index) {
			// var w = $(this).outerWidth();
			// var h = $(this).outerHeight();
			// $(this).find('canvas').attr('width', w);
			// $(this).find('canvas').attr('height', h);
			// $(this).find('canvas').css({
			// 	'width': w,
			// 	'height': h
			// });
			// });

			if (ww >= 1200) {
				$(".main-nav-list .list-open").removeClass("list-open");
				$(".main-nav-list .open").removeClass("open");
				$('a[data-js="btn-burger"]').removeClass("active");
			}
		});

		// Nice sekect
		$('.cust-select').niceSelect();
		$('.bite-jobs-control-select').niceSelect();

		$('.cust-select li.option').mouseup(function (e) {
			$('.b-search-result .panel').removeClass('opened');
		});

		$('.clinic-suggestions li a').mouseup(function (e) {
			$('.b-search-result .panel').removeClass('opened');
		});


		setTimeout(function () {
			if ($('.bite-jobs-control-select').hasClass('nice-select')) {

			} else {
				$('.bite-jobs-control-select').niceSelect();
			}
		}, 500);


		coverImage();
		// AOS.init();
	});

})(jQuery);
